import React, { useEffect } from 'react';
import './Pcbmounting.css';

const Pcbmounting = () => {
    useEffect(() => {
        console.log('Pcbmounting useEffect running');
        const elements = document.querySelectorAll('.animate-on-scroll');
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    console.log(`${entry.target.className} isIntersecting: ${entry.isIntersecting}`);
                    if (entry.isIntersecting) {
                        entry.target.classList.add('animate');
                    }
                });
            },
            { threshold: 0.2 }
        );

        elements.forEach((element) => {
            console.log('Observing:', element);
            observer.observe(element);
        });

        return () => {
            elements.forEach((element) => observer.unobserve(element));
        };
    }, []);

    const keyTopics = [
        {
            title: "Bill of Materials Preparation Process",
            description: "Preparing accurate BOMs to ensure component availability for IoT PCB assembly."
        },
        {
            title: "Component Placement Process",
            description: "Precisely placing components on PCBs for optimal functionality in embedded systems."
        },
        {
            title: "Soldering Process",
            description: "Applying soldering techniques to secure components reliably on IoT PCBs."
        },
        {
            title: "PCB Cleaning Process",
            description: "Cleaning PCBs to remove flux and contaminants, ensuring reliability."
        },
        {
            title: "Inspection and Quality Control Process",
            description: "Inspecting assembled PCBs to ensure quality and performance standards."
        },
        {
            title: "Reflow and Wave Soldering Process",
            description: "Using reflow and wave soldering for consistent, high-quality PCB assembly."
        },
        {
            title: "Stencil Application Process",
            description: "Applying solder paste via stencils for precise SMT component placement."
        },
        {
            title: "Surface-Mount Technology (SMT) Assembly Process",
            description: "Assembling SMT components for compact, high-performance IoT PCBs."
        },
        {
            title: "Through-Hole Assembly Process",
            description: "Mounting through-hole components for robust IoT device connections."
        }
    ];

    return (
        <div className="detail-page">
            <h1 className="detail-heading animate-on-scroll" style={{ animationDelay: '0.1s' }}>
                PCB Mounting and Assembly
            </h1>
            <p className="detail-intro animate-on-scroll" style={{ animationDelay: '0.2s' }}>
                Our PCB mounting and assembly services deliver precise, reliable, and efficient solutions for IoT and embedded systems, ensuring high-quality production and performance.
            </p>
            <h2 className="detail-subheading animate-on-scroll" style={{ animationDelay: '0.3s' }}>
                Key Topics
            </h2>
            <ul className="detail-topics">
                {keyTopics.map((topic, index) => (
                    <li
                        key={index}
                        className="topic-card animate-on-scroll"
                        style={{ animationDelay: `${0.4 + index * 0.05}s` }}
                    >
                        <strong className="topic-title">{topic.title}</strong>
                        <p className="topic-description">{topic.description}</p>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default Pcbmounting;